<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Employees
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-input
          v-model="searchString"
          class="q-mb-md"
          label="Search"
          dense
          clearable
          debounce="300"
        />
        <div
          class="relative-position"
          style="min-height: 200px; max-height: 75vh; overflow: auto;"
        >
          <q-list
            bordered
            separator
          >
            <q-item
              v-for="user in usersOrderedByAlreadyAssignedFirst"
              :key="user.id"
              clickable
              :active="$_.includes(roleUserIds, user.id)"
              @click.stop="role.users.toggle(user)"
            >
              <q-item-section avatar>
                <q-checkbox
                  class="no-pointer-events"
                  :model-value="$_.includes(roleUserIds, user.id)"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label class="row items-center">
                  <div class="q-mr-auto">
                    {{ user.firstName }} <span class="sensitive-data">{{ user.lastName }}</span>
                  </div>
                  <q-chip
                    v-if="user.superUser"
                    class="q-my-none"
                    dense
                  >
                    Super User
                  </q-chip>
                  <q-chip
                    v-else-if="user.admin"
                    class="q-my-none"
                    dense
                  >
                    Admin
                  </q-chip>
                  <q-chip
                    v-else-if="user.employee"
                    class="q-my-none"
                    dense
                  >
                    Employee
                  </q-chip>
                </q-item-label>
                <q-item-label
                  class="sensitive-data"
                  caption
                >
                  {{ user.email || 'Missing email' }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
          <q-inner-loading :showing="users.loading" />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import Role from 'src/models/access-control/Role'

export default {
  name: 'SelectRoleUsersDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    role: {
      type: Role,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      searchString: '',
      shown: false,
      alreadyAssignedRoleUserIds: []
    }
  },
  models: {
    users: {
      fields: ['id', 'photo', 'firstName', 'lastName', 'email', 'admin', 'employee', 'superUser'],
      variables () {
        return {
          userRole: 'employees',
          limit: 1000,
          orderBy: 'firstName',
          searchString: this.searchString
        }
      }
    }
  },
  computed: {
    roleUserIds () {
      return _.map(this.role.users.data, 'id')
    },
    usersOrderedByAlreadyAssignedFirst () {
      const [roleUsers, nonRoleUsers] = _.partition(this.users.data, user => {
        return _.includes(this.alreadyAssignedRoleUserIds, user.id)
      })
      return [...roleUsers, ...nonRoleUsers]
    }
  },
  watch: {
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.alreadyAssignedRoleUserIds = _.map(this.role.users.data, 'id')
      this.shown = true
    }
  }
}
</script>
